import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthGuardData, createAuthGuard} from "keycloak-angular";
import Keycloak from "keycloak-js";
import {RealmService} from "../services/realm.service";
import {ConfigurationService} from "../../shared/services/configuration.service";


const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    routerState: RouterStateSnapshot,
    authData: AuthGuardData
): Promise<boolean | UrlTree> => {
    const {authenticated, grantedRoles} = authData;
    const keycloak = inject(Keycloak);
    const realmService = inject(RealmService);

    if (authenticated) {
        const requiredRole = route.data['role'];

        if (requiredRole && requiredRole.length > 0) {
            const hasRequiredRole = (role: string): boolean =>
                Object.values(grantedRoles.resourceRoles).some((roles) => roles.includes(role));

            if (hasRequiredRole(requiredRole)) {
                return true;
            }
        } else {
            return true;
        }
    }

    if (keycloak.realm && keycloak.realm.length > 0) {
        const urlParams = new URLSearchParams(globalThis.location.search);
        const loginHint = realmService.mail ?? urlParams.get('email') ?? '';

        await keycloak.login({
            redirectUri: globalThis.location.origin + routerState.url,
            loginHint: loginHint,
        });
        return false;
    }

    const currentUrl = new URL(globalThis.location.href);
    const encodedOriginUrl = encodeURIComponent(currentUrl.toString());
    const config = inject(ConfigurationService).configuration;
    globalThis.location.href = `${config.api.realmChooserUrl}/?origin=${encodedOriginUrl}`;
    return false;
};

export const canActivateAuthRole = createAuthGuard<CanActivateFn>(isAccessAllowed);
